import { Injectable } from '@angular/core';
import { FILTERTS_ } from '../constants/common-enum';

@Injectable({
  providedIn: 'root'
})
export class FilterStateService {

  private filtersMap: { [component: string]: any } = {};

  // Set filters for a specific component
  setFilters(component: string, filters: any) {
    // Clean the filters by removing null/undefined values
    const cleanedFilters = Object.fromEntries(
      Object.entries(filters)
        .map(([key, value]) => {
          let normalized =
            value === undefined || value === 'undefined' || value === 'null'
              ? null
              : value;
          if (typeof normalized === 'string') {
            normalized = decodeURIComponent(normalized);
          }
          return [key, normalized];
        })
        .filter(([_, value]) => value !== null && value !== '')
    );

    // Store the cleaned filters in the service map and localStorage
    this.filtersMap[component] = cleanedFilters;
    localStorage.setItem(
      `${FILTERTS_}${component}`,
      JSON.stringify(cleanedFilters)
    );
  }

  // Get filters for a specific component
  getFilters<T = any>(component: string): T {
    // Check the in-memory map first
    if (!this.filtersMap[component]) {
      const stored = localStorage.getItem(`${FILTERTS_}${component}`);
      this.filtersMap[component] = stored ? JSON.parse(stored) : {};
    }
    return this.filtersMap[component] || ({} as T);
  }

  // Clear filters for a specific component
  clearFilters(component: string) {
    delete this.filtersMap[component];
    localStorage.removeItem(`${FILTERTS_}${component}`);
  }

  // Clear filters for all components
  clearAllFilters(): void {
    const keys: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key?.startsWith(FILTERTS_)) {
        keys.push(key);
      }
    }
    keys.forEach(key => localStorage.removeItem(key));
    this.filtersMap = {};
  }
}
